import { render, staticRenderFns } from "./order-repairs.vue?vue&type=template&id=72f4a64d&"
import script from "./order-repairs.vue?vue&type=script&lang=js&"
export * from "./order-repairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports